import { createColumnHelper } from "@tanstack/react-table";
import { ActionCell, AssetType, ImageDisplay } from "./ColumnUtiils";
import { FilterList as FilterIcon } from "@mui/icons-material";
const columnHelper = createColumnHelper();
// Column definitions
export const assetColumns = (handleStatusChange, setOpen, setEditData, setAssetStatusChange, setRefresh) => {
  return [
    columnHelper.accessor("serial_no", {
      // header: t("pages.reports.asset.serial_number"),
      header: "S.No",
      size: 1,
      muiTableBodyCellProps: {
        sx: {
          ".MuiCheckbox-root": {
            padding: 0,
          },
          textAlign: "left",
          fontSize: { xs: "2.09vw", sm: "1.2vw", md: "0.833vw" },
          color: "#474747",
          paddingY: { xs: "2vw", sm: "0.7vw" },
          zIndex: 1,
          fontWeight: 400,
          borderColor: "rgb(246, 210, 127)",
          "&.MuiTableCell-root:first-of-type": {
            position: "sticky",
            left: 0,
            // background: "#FFF7D6",
            zIndex: 2,
            "@media (max-width: 768px)": {
              position: "relative", // Disable sticky on small screens
            },
          },
        },
      },
      muiTableHeadCellProps: {
        sx: {
          ".MuiCheckbox-root": {
            padding: 0,
            color: "#FFE097 !important",
          },
          ".css-1lderhz": {
            display: "none !important",
          },
          "& .Mui-TableHeadCell-Content": { justifyContent: "start" },
          paddingY: { xs: "2vw", sm: "0.7vw" },
          fontSize: { xs: "2.564vw", sm: "1.439vw", md: "0.972vw" },
          background: "linear-gradient(180deg, #DEA829 0%, #FE8888 100%)",
          color: "#ffffff",
  
          "& .MuiTableSortLabel-icon": {
            color: "#FFFFFF !important",
          },
          "&.MuiTableCell-root:first-of-type": {
            position: "sticky",
            left: 0,
            // background: "#FFF7D6",
            zIndex: 2,
            "@media (max-width: 768px)": {
              position: "relative", // Disable sticky on small screens
            },
          },
        },
      },
      enableSorting: false,
    }),
    columnHelper.accessor("asset_name", {
      // header: t("pages.reports.asset.asset_no"),
      header: "Asset Name",
      muiTableBodyCellProps: {
        sx: {
          ".MuiCheckbox-root": {
            padding: 0,
            color: "#D9A62E !important",
          },
          textAlign: "left",
          fontSize: { xs: "2.09vw", sm: "1.2vw", md: "0.833vw" },
          color: "#474747",
          paddingY: { xs: "2vw", sm: "0.7vw" },
          zIndex: 1,
          fontWeight: 400,
          borderColor: "rgb(246, 210, 127)",
          "&.MuiTableCell-root:first-of-type": {
            position: "sticky",
            left: 0,
            // background: "#FFF7D6",
            zIndex: 2,
            "@media (max-width: 768px)": {
              position: "relative", // Disable sticky on small screens
            },
          },
        },
      },
      muiTableHeadCellProps: {
        sx: {
          ".MuiCheckbox-root": {
            padding: 0,
            color: "#FFE097 !important",
          },
          ".css-1lderhz": {
            display: "none !important",
          },
          "& .Mui-TableHeadCell-Content": { justifyContent: "start" },
          paddingY: { xs: "2vw", sm: "0.7vw" },
          fontSize: { xs: "2.564vw", sm: "1.439vw", md: "0.972vw" },
          background: "linear-gradient(180deg, #DEA829 0%, #FE8888 100%)",
          color: "#ffffff",
  
          "& .MuiTableSortLabel-icon": {
            color: "#FFFFFF !important",
          },
          "&.MuiTableCell-root:first-of-type": {
            position: "sticky",
            left: 0,
            // background: "#FFF7D6",
            zIndex: 2,
            "@media (max-width: 768px)": {
              position: "relative", // Disable sticky on small screens
            },
          },
        },
      },
      size: 50,
      enableSorting: false,
    }),
    columnHelper.accessor("asset_code", {
      // header: t("pages.reports.asset.code"),
      header: "Code",
      size: 50,
      enableSorting: false,
    }),
    columnHelper.accessor("asset_status", {
      header: "Status",
      size: 50,
      Cell: ({ cell }) => (
        <AssetType cell={cell} onStatusChange={handleStatusChange} setAssetStatusChange={setAssetStatusChange} />
      ),
      enableSorting: false,
      enableColumnFilter: true,
    }),
    columnHelper.accessor("category", {
      // header: t("pages.reports.asset.type"),
      header: "Category",
      size: 50,
      enableSorting: false,
    }),
    columnHelper.accessor("asset_image", {
      // header: t("pages.reports.asset.image"),
      header: "Image",
      size: 50,
      Cell: ({ cell }) => <ImageDisplay cell={cell} />,
      enableColumnFilter: false,
      enableSorting: false,
    }),
    columnHelper.accessor("location", {
      // header: t("pages.reports.asset.location"),
      header: "Location",
      size: 50,
      enableSorting: false,
      enableColumnFilter: false,
    }),
    columnHelper.accessor("action", {
      header: "Action",
      size: 50,
      enableSorting: false,
      enableColumnFilter: false,
      Cell: ({ row }) => (
        <ActionCell row={row} editopen={setOpen} setEditData={setEditData} setRefresh={setRefresh} />
      ),
    }),
  ];
};
